if (!customElements.get('review-text')) {
  // Shows "Read more" only when the review is clamped, and toggles it open/closed.
  class ReviewText extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('[data-text]');
      this.button = this.querySelector('button');
      if (!this.text || !this.button) return;

      this.button.addEventListener('click', this.toggle.bind(this));
      this.observer = new ResizeObserver(() => this.check());
      this.observer.observe(this.text);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    check() {
      if (this.classList.contains('is-expanded')) return;
      this.button.hidden = this.text.scrollHeight <= this.text.clientHeight + 1;
    }

    toggle() {
      const expanded = this.classList.toggle('is-expanded');
      this.button.setAttribute('aria-expanded', expanded);
      this.button.textContent = expanded ? this.button.dataset.lessLabel : this.button.dataset.moreLabel;
    }
  }
  customElements.define('review-text', ReviewText);
}
